import { useState } from "react";
import { IPopupWithoutProps, LangTranslate } from "../../../types/types";
import { useDispatch, useSelector } from "react-redux";
import { updateListTranslate } from "../../../services/slices/admin.slice";
import { adminListSelector } from "../../../services/selectors/admin.selectors";
import popupStyles from "./tablePopup.module.css";
import CloseButton from "../../closeButton/closeButton";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import Modal from "../modal/Modal";
import GeneralSuccessPopup from "../generalSuccessPopup/generalSuccessPopup";

const TablePopup = ({
  onClose,
  onSaveAll,
}: IPopupWithoutProps & { onSaveAll: () => Promise<boolean> }) => {
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editedValue, setEditedValue] = useState<string>("");
  const LangTranslateArr = useSelector(adminListSelector) as LangTranslate[];
  const dispatch = useDispatch();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  function handleEdit(index: number): void {
    setEditIndex(index);
if (Array.isArray(LangTranslateArr) && LangTranslateArr[index]) {
  setEditedValue(LangTranslateArr[index].translate);
}
  }

  function handleSave(index: number): void {
    dispatch(updateListTranslate({ index, newTranslate: editedValue }));
    console.log(LangTranslateArr);
    
    setEditIndex(null);
  }
    const [success, setSuccess] = useState(false);
  
const handleConfirm = async () => {
  const confirm = window.confirm(t('ARE_YOU_SURE_SAVE_CHANGES'));
  if (!confirm) return; 
  const success = await onSaveAll(); 

};


  if (showSuccessPopup) {
    return (

      <Modal onClose={onClose}>
        <GeneralSuccessPopup
          onClose={() => {
            setShowSuccessPopup(false);
            onClose(); // גם סוגר את TablePopup
          }}
        />
      </Modal>
    );
  }

  return (
    <>
      <div className={popupStyles.overlay}></div>
      <article className={popupStyles.popup}>
        <CloseButton onClick={onClose} />
        <div className={popupStyles["table-scroll"]}>
          <table className={popupStyles.lang_table}>
            <thead>
              <tr>
                <th>{t("LANGUAGE")}</th>
                <th>{t("TRANSLATE")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {LangTranslateArr.map((x, index) => (
                <tr key={x.language}>
                  <td>{x.language}</td>
                  <td>
                    {editIndex === index ? (
                      <textarea
                        value={editedValue}
                        onChange={(e) => setEditedValue(e.target.value)}
                      />
                    ) : (
                      x.translate
                    )}
                  </td>
                  <td>
                    {editIndex === index ? (
                      <button
                        type="button"
                        className={popupStyles.save_btn}
                        onClick={() => handleSave(index)}
                      ></button>
                    ) : (
                      <button
                        type="button"
                        className={popupStyles.edit_btn}
                        onClick={() => handleEdit(index)}
                      ></button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <br />
        <div className={popupStyles.divOk}>
          <button
            type="button"
            className={popupStyles.ok}
            onClick={handleConfirm}
          >
            {t("CONFIRM")}
          </button>
        </div>
      </article>
    </>
  );
};

export default TablePopup;
